<template>
  <div class="leftBarTabsItemContent">
    <v-form id="leftBarLayersForm" ref="form">
      <v-radio-group v-model="baseMapRadio" style="margin: 0; padding: 0">
        <v-container>
          <v-row>
            <v-col md="6">
              <v-radio :value="mapBasemapName.TOPO">
                <template slot="label">
                  <v-img src="images/topo.png" width="80" height="60"></v-img>
                  <span class="switch_layer_text">{{
                    this.$t("common.topoLayer")
                  }}</span>
                </template></v-radio
              >
            </v-col>
            <v-col md="6">
              <v-radio :value="mapBasemapName.ORTHO">
                <template slot="label"
                  ><v-img src="images/ortho.png" width="80" height="60"></v-img>
                  <span class="switch_layer_text">{{
                    this.$t("common.orthoLayer")
                  }}</span>
                </template></v-radio
              ></v-col
            >
          </v-row>
        </v-container>
      </v-radio-group>

      <div>
        <!-- <v-container>
          <v-row>
            <v-col :title="$t('common.title_onOffLayer')">
              <div style="display: flex; flex-direction: row">
                <v-checkbox
                  prepend-icon="table_view"
                  v-model="dynamicLayersSelected"
                  :value="GLOBAL.MAP_LAYER.NAME.TABLE_LAYER"
                  :label="$t('common.tableLayer')"
                ></v-checkbox></div
            ></v-col>

            <v-col :title="$t('common.title_onOffLayer')">
              <v-radio-group v-model="presetLayerSelected" row>
                <div style="display: flex; flex-direction: row">
                  <v-btn
                    :title="$t('common.title_close')"
                    icon
                    v-if="
                      presetLayerSelected ==
                      GLOBAL.MAP_LAYER.NAME.BUILDING_LAYER
                    "
                    @click="presetLayerSelected = null"
                    ><v-icon>close</v-icon></v-btn
                  >
                  <v-btn icon disabled v-else>
                    <v-icon>apartment</v-icon>
                  </v-btn>
                  <v-radio
                    small
                    :value="GLOBAL.MAP_LAYER.NAME.BUILDING_LAYER"
                    :label="$t('common.buildingLayer')"
                    :key="GLOBAL.MAP_LAYER.NAME.BUILDING_LAYER"
                    prepend-icon="apartment"
                  ></v-radio>
                </div>
                <div style="display: flex; flex-direction: row">
                  <v-btn
                    icon
                    v-if="
                      presetLayerSelected == GLOBAL.MAP_LAYER.NAME.LOT_LAYER
                    "
                    @click="presetLayerSelected = null"
                  >
                    <v-icon
                      v-if="
                        presetLayerSelected == GLOBAL.MAP_LAYER.NAME.LOT_LAYER
                      "
                      >close</v-icon
                    ></v-btn
                  >
                  <v-btn icon disabled v-else
                    ><v-icon>flip_to_back</v-icon></v-btn
                  >
                  <v-radio
                    :value="GLOBAL.MAP_LAYER.NAME.LOT_LAYER"
                    :label="$t('common.lotLayer')"
                    :key="GLOBAL.MAP_LAYER.NAME.LOT_LAYER"
                  ></v-radio>
                </div>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container> -->

        <v-container>
          <v-dialog
            maxWidth="90%"
            width="500"
            scrollable
            v-model="addLayerModal"
            :persistent="true"
            :style="`z-index: ${core.confirmationIndex};`"
          >
            <template v-slot:activator="{ on, attrs }">
              <div>
                <v-btn
                  :title="$t('common.title_addLayer')"
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  small
                  ><v-icon>add</v-icon>{{ $t("common.addLayer") }}</v-btn
                >&nbsp;&nbsp;&nbsp;

                <v-btn
                  :title="$t('common.title_removeLayers')"
                  color="error"
                  dark
                  small
                  @click.stop="core.deleteAllLayers"
                  ><v-icon>layers_clear</v-icon
                  >{{ $t("common.removeLayers") }}</v-btn
                >
              </div>
            </template>
            <v-card>
              <v-toolbar dark color="secondary"
                >{{ $t("common.addLayer") }} <v-spacer></v-spacer
                ><v-btn icon @click.stop="addLayerModal = false"
                  ><v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-title></v-card-title>
              <v-card-text>
                <v-btn
                  x-large
                  color="primary"
                  href="https://geodata.gov.hk/"
                  text
                  target="_blank"
                  ><v-icon>link</v-icon>
                  {{ $t("common.reviewGeoData") }}
                </v-btn>

                <v-select
                  :label="$t('common.layerType')"
                  v-model="addLayerType"
                  :items="layerTypeFormatsArray"
                  item-disabled="disabled"
                  item-text="label"
                  item-value="type"
                >
                </v-select>
                <v-text-field
                  outlined
                  :rules="[core.rules.required, validNewLayerUrl]"
                  v-model="addLayerUrl"
                  :label="$t('common.url')"
                ></v-text-field>
                <v-text-field
                  outlined
                  :rules="[core.rules.required, validNewLayerNameState]"
                  v-model="addLayerLayerName"
                  :label="$t('common.layerName')"
                ></v-text-field>
                <v-text-field
                  v-if="enable_params"
                  outlined
                  :rules="[]"
                  v-model="addLayerParams"
                  :label="$t('common.layerParams')"
                  :placeholder="$t('common.layerParamsMessage')"
                ></v-text-field>
                <v-text-field
                  v-if="enable_layers"
                  outlined
                  :rules="[core.rules.required]"
                  v-model="addLayerLayers"
                  :label="$t('common.layerLayers')"
                  :placeholder="$t('common.layerLayersMessage')"
                ></v-text-field>
                <v-text-field
                  v-if="enable_where"
                  outlined
                  :rules="[]"
                  v-model="addLayerWhere"
                  :label="$t('common.layerWhere')"
                  :placeholder="$t('common.layerWhereMessage')"
                ></v-text-field>

                <ImportOption
                  v-if="enable_crs || enable_latlng"
                  :enable_latlng="enable_latlng"
                  :enable_crs="enable_crs"
                  :current_crs_option="current_crs_option"
                  :current_fields="current_fields"
                  :current_latitude_field="current_latitude_field"
                  :current_longitude_field="current_longitude_field"
                  :change_current_latitude_field="change_current_latitude_field"
                  :change_current_longitude_field="
                    change_current_longitude_field
                  "
                  :change_current_crs_option="change_current_crs_option"
                ></ImportOption>

                <v-list-group v-if="enable_color" class="switch_layer_option">
                  <template v-slot:activator>
                    <v-container fluid
                      ><v-icon>color_lens</v-icon>&nbsp;&nbsp;{{
                        $t("common.style")
                      }}
                    </v-container>
                  </template>
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-flex xs12 md12
                        >{{ $t("common.layerColor")
                        }}<v-color-picker
                          hide-inputs
                          v-model="addLayerStyleFillColor"
                        ></v-color-picker
                      ></v-flex>
                    </v-layout>
                  </v-container>
                </v-list-group>
              </v-card-text>

              <v-card-actions>
                <v-chip class="ma-2" small label color="#FFF">{{
                  $t("common.supportCRSMessage")
                }}</v-chip>
                <v-spacer></v-spacer>
                <v-btn large text @click.stop="addLayerModal = false">{{
                  $t("common.cancel")
                }}</v-btn>
                <v-btn
                  large
                  color="primary"
                  :disabled="
                    addLayerType == null ||
                    typeof validNewLayerNameState === 'string' ||
                    !validNewLayerNameState ||
                    typeof validNewLayerUrl === 'string' ||
                    !validNewLayerUrl ||
                    (addLayerType == layerTypeFormats.WMS &&
                      (typeof validNewLayers === 'string' || !validNewLayers))
                  "
                  @click.stop="addLayerHandler"
                  >{{ $t("common.ok") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>

        <v-list-item
          style=""
          :key="dynamicLayer.label"
          v-for="(dynamicLayer, index) in core.dynamicLayers"
        >
          <div :title="$t('common.title_onOffLayer')">
            <v-checkbox
              :key="dynamicLayer.id"
              v-model="dynamicLayersSelected"
              :value="dynamicLayer.id"
              :label="dynamicLayer.title"
              on-icon="visibility"
              off-icon="visibility_off"
            >
            </v-checkbox>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            :title="$t('common.title_tabsExtent')"
            v-if="
              dynamicLayer.type !== layerTypeFormats.WMS &&
              dynamicLayer.type !== layerTypeFormats.ARCGIS &&
              dynamicLayersSelected.some(function (layer) {
                return layer == dynamicLayer.id;
              })
            "
            icon
            @click.stop="extentLayer(dynamicLayer)"
          >
            <v-icon>zoom_out_map</v-icon>
          </v-btn>
          <v-btn
            :title="$t('common.title_editLayer')"
            icon
            @click.stop="
              currentEditLayer = dynamicLayer;
              addLayerModal = true;
            "
          >
            <v-icon>edit</v-icon>
          </v-btn>

          <v-btn
            icon
            :title="$t('common.title_switchLayerUp')"
            @click.stop="core.chgindexOverLay(index, true)"
            ><v-icon>mdi-arrow-up-bold</v-icon></v-btn
          >
          <v-btn
            :title="$t('common.title_switchLayerDown')"
            icon
            @click.stop="core.chgindexOverLay(index, false)"
            ><v-icon>mdi-arrow-down-bold</v-icon></v-btn
          >

          <v-btn
            :title="$t('common.title_removeLayer')"
            icon
            @click.stop="showDeleteLayerDialog(dynamicLayer.title)"
          >
            <v-icon>mdi-delete</v-icon></v-btn
          >
        </v-list-item>
      </div>
    </v-form>
  </div>
</template>


<script>
import * as GLOBAL from "./Global.js";
import ImportOption from "./ImportOption";

export default {
  props: ["core", "leftBar"],

  watch: {
    presetLayerSelected: function (newVal, oldVal) {
      if (oldVal) {
        this.core.switchOverlay(oldVal, false);
      }

      if (newVal) {
        this.core.switchOverlay(newVal, true);
      } else {
        //close table item sublayer identify
        if (this.core.enableIdentifyTableItemSubLayer) {
          this.core.enableIdentifyTableItemSubLayer = false;
        }
      }

      // this.checkLayerInZoom();
    },

    dynamicLayersSelected: function (newVal, oldVal) {
      //compare new & old to delete non existing layer
      for (let i = 0; i < oldVal.length; i++) {
        let old_exist = false;
        for (let j = 0; j < newVal.length; j++) {
          if (oldVal[i] == newVal[j]) {
            old_exist = true;
            break;
          }
        }
        if (!old_exist) {
          this.core.switchOverlay(oldVal[i], false);
        }
      }
      //compare new & old to add layer
      for (let i = 0; i < newVal.length; i++) {
        let old_exist = false;
        for (let j = 0; j < oldVal.length; j++) {
          if (oldVal[j] == newVal[i]) {
            old_exist = true;
            break;
          }
        }
        if (!old_exist) {
          this.core.switchOverlay(newVal[i], true);
        }
      }
    },

    addLayerType(val) {
      this.clearImportOption();
      //for enable features with different type
      if (val == GLOBAL.LAYER_TYPE_FORMAT.WFS) {
        this.enable_params = true;
        this.enable_color = true;
        this.enable_layers = false;
        this.enable_where = false;
      } else if (val == GLOBAL.LAYER_TYPE_FORMAT.ARCGIS) {
        this.enable_params = false;
        this.enable_color = false;
        this.enable_layers = false;
        this.enable_where = true;
      } else if (val == GLOBAL.LAYER_TYPE_FORMAT.WMS) {
        this.enable_params = false;
        this.enable_color = false;
        this.enable_layers = true;
        this.enable_where = false;
      } else {
        this.enable_params = false;
        this.enable_color = true;
        this.enable_layers = false;
        this.enable_where = false;
      }
    },

    addLayerUrl() {
      this.clearImportOption();
    },

    baseMapRadio(val) {
      this.core.changeBasemap(val);
    },

    addLayerModal(val) {
      this.$refs.form.resetValidation();
      if (this.currentEditLayer != null && val) {
        this.addLayerType = this.currentEditLayer.type;
        this.addLayerUrl = this.currentEditLayer.url;
        this.addLayerLayerName = this.currentEditLayer.title;
        this.addLayerStyleFillColor = this.currentEditLayer.style.fillColor;
        this.addLayerParams = this.currentEditLayer.params;
        this.addLayerLayers = this.currentEditLayer.layers;
        this.addLayerWhere = this.currentEditLayer.where;
      } else if (!val) {
        this.currentEditLayer = null;
        // this.addLayerType = GLOBAL.LAYER_TYPE_FORMAT_ARRAY[0];
        this.addLayerType = null;
        this.addLayerUrl = "";
        this.addLayerLayerName = "";
        this.addLayerParams = "";
        this.addLayerLayers = "";
        this.addLayerWhere = "";
      }
    },
  },
  data() {
    return {
      GLOBAL: GLOBAL,

      addLayerModal: false,

      dynamicLayersSelected: [GLOBAL.MAP_LAYER.NAME.TABLE_LAYER],
      presetLayerSelected: null,

      //add layer modal
      layerTypeFormats: GLOBAL.LAYER_TYPE_FORMAT,
      layerTypeFormatsArray: GLOBAL.LAYER_TYPE_FORMAT_ARRAY,
      // addLayerType: GLOBAL.LAYER_TYPE_FORMAT_ARRAY[0],
      addLayerType: null,
      addLayerUrl: "",
      addLayerLayerName: "",
      addLayerParams: "",
      addLayerLayers: "",
      addLayerWhere: "",
      addLayerStyleFillColor: null,

      //radio
      baseMapRadio: GLOBAL.MAP_BASEMAP_NAME.TOPO,
      mapBasemapName: GLOBAL.MAP_BASEMAP_NAME,

      currentEditLayer: null,

      //for import option
      enable_params: false,
      enable_layers: false,
      enable_where: false,
      enable_latlng: false,
      enable_color: false,
      enable_crs: false,

      current_latitude_field: null,
      current_longitude_field: null,
      current_crs_option: GLOBAL.IMPORT.CRS_OPTIONS.WGS1984,
      current_fields: [],
    };
  },

  methods: {
    init() {
      this.core.leftBar.chgToolBarButtons({
        // toolbarTitle: this.$t("common.manageLayers"),
      });
    },

    checkLayerInZoom() {
      //overlay zoom checking & message
      let showMessage = false,
        zoomLevel = this.core.map.getZoom();

      switch (this.presetLayerSelected) {
        case GLOBAL.MAP_LAYER.NAME.LOT_LAYER:
          if (zoomLevel <= 16) {
            showMessage = true;
          }
          break;
        case GLOBAL.MAP_LAYER.NAME.BUILDING_LAYER:
          if (zoomLevel <= 14) {
            showMessage = true;
          }
          break;
        //for unchecked item then close the existing snackbar
        default:
          showMessage = false;
          break;
      }

      if (showMessage) {
        this.core.showNewSnackBar(
          this.$t("common.zoomInToEnableFeatureMessage")
        );
      } else {
        this.core.closeNewSnackBar(
          this.$t("common.zoomInToEnableFeatureMessage")
        );
      }
    },

    setPresetLayerSelected(val) {
      this.presetLayerSelected = val;
    },

    extentLayer(dynamicLayer) {
      let layer = this.core.dynamicLayerDrawnItems._layers[
        dynamicLayer.leaflet_id
      ];

      this.core.map.fitBounds(layer.getBounds());
    },

    clearImportOption() {
      this.enable_latlng = false;
      this.enable_crs = false;
      this.current_latitude_field = null;
      this.current_longitude_field = null;
      this.current_crs_option = GLOBAL.IMPORT.CRS_OPTIONS.WGS1984;
    },

    showDeleteLayerDialog(dynamicLayerTitle) {
      this.core.showConfirmDialogForSwitchLayers(dynamicLayerTitle);
    },

    async addLayerHandler() {
      //verify & init load file for select options
      let result = await this.loadAndVerifyUrl();
      if (!result) {
        return;
      }

      if (this.currentEditLayer != null) {
        let id = this.currentEditLayer.id.toString();
        this.core.editLayer(
          id,
          this.addLayerType,
          this.addLayerLayerName,
          this.addLayerUrl,
          this.addLayerParams,
          this.addLayerLayers,
          this.addLayerWhere,
          {
            crsOption: this.current_crs_option,
            latitudeField: this.current_latitude_field,
            longitudeField: this.current_longitude_field,
          },
          this.addLayerStyle
        );

        let isOn = this.dynamicLayersSelected.some(
          (selectedLayer) => selectedLayer == id
        );
        if (isOn) {
          this.core.switchOverlay(id, false);
          this.core.switchOverlay(id, true);
        }
      } else {
        this.core.addLayer(
          this.addLayerType,
          this.addLayerLayerName,
          this.addLayerUrl,
          this.addLayerParams,
          this.addLayerLayers,
          this.addLayerWhere,
          {
            crsOption: this.current_crs_option,
            latitudeField: this.current_latitude_field,
            longitudeField: this.current_longitude_field,
          },
          this.addLayerStyle
        );
      }

      this.addLayerModal = false;
    },

    async loadAndVerifyUrl() {
      try {
        if (this.addLayerType == GLOBAL.LAYER_TYPE_FORMAT.CSV) {
          if (
            this.enable_latlng &&
            this.enable_crs &&
            this.current_latitude_field &&
            this.current_longitude_field &&
            this.current_crs_option &&
            this.current_fields
          ) {
            return true;
          }

          let res = await this.core.customFetch({
            url: this.addLayerUrl,
            error_message: this.$t("common.connectLayerNetworkMessage"),
          });

          res = this.core.import.generateCSVHeaders(res);

          if (res) {
            this.current_fields = res.fields;
            this.loadCurrentLatitudeField(res);
            this.loadCurrentLongitudeField(res);
            this.loadCurrentCRSOption();
          }
          return false;
        } else if (
          this.addLayerType == GLOBAL.LAYER_TYPE_FORMAT.GML ||
          this.addLayerType == GLOBAL.LAYER_TYPE_FORMAT.KML ||
          this.addLayerType == GLOBAL.LAYER_TYPE_FORMAT.GEOJSON
        ) {
          if (this.enable_crs && this.current_crs_option) {
            return true;
          } else {
            this.loadCurrentCRSOption();
          }
        } else {
          // this.current_fields = null
          this.current_latitude_field = null;
          this.current_longitude_field = null;
          this.current_crs_option = null;
          return true;
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    },

    loadCurrentLatitudeField(res) {
      let me = this;
      this.enable_latlng = true;
      this.current_latitude_field =
        res.fields.find(function (field) {
          if (
            me.currentEditLayer &&
            field == me.currentEditLayer.options.latitudeField
          ) {
            return true;
          }
        }) || res.latitude_field;
    },

    loadCurrentLongitudeField(res) {
      let me = this;
      this.enable_latlng = true;
      this.current_longitude_field =
        res.fields.find(function (field) {
          if (
            me.currentEditLayer &&
            field == me.currentEditLayer.options.longitudeField
          ) {
            return true;
          }
        }) || res.longitude_field;
    },

    loadCurrentCRSOption() {
      this.enable_crs = true;
      let tmpCurrentEditLayer = this.currentEditLayer;
      this.current_crs_option =
        GLOBAL.IMPORT.CRS_OPTIONS_ARRAY.find(function (crs) {
          if (
            tmpCurrentEditLayer &&
            crs == tmpCurrentEditLayer.options.crsOption
          ) {
            return true;
          }
        }) || this.current_crs_option;
    },

    change_current_longitude_field(val) {
      this.current_longitude_field = val;
    },
    change_current_latitude_field(val) {
      this.current_latitude_field = val;
    },
    change_current_crs_option(val) {
      this.current_crs_option = val;
    },
  },

  computed: {
    addLayerStyle() {
      return {
        fillColor: this.addLayerStyleFillColor,
      };
    },

    validNewLayerUrl() {
      if (this.addLayerUrl !== "") {
        return true;
      } else {
        return false;
      }
    },

    validNewLayers() {
      if (this.addLayerLayers !== "") {
        return true;
      } else {
        return false;
      }
    },

    validNewLayerNameState() {
      if (this.addLayerLayerName === "") {
        return false;
      }

      let result = this.core.dynamicLayers.some((item) => {
        if (
          (item.title.toString().toLowerCase() ==
            this.addLayerLayerName.toString().toLowerCase() &&
            this.currentEditLayer == null) ||
          (this.currentEditLayer != null &&
            item.title.toString().toLowerCase() ==
              this.addLayerLayerName.toString().toLowerCase() &&
            this.currentEditLayer.id != item.id)
        ) {
          return true;
        }
      });

      if (!result) {
        return true;
      } else {
        return this.$t("common.layerNameExisting");
      }
    },
  },

  components: { ImportOption },
};
</script>